<template>
  <div v-loading.fullscreen.lock="pageLoading">
    <div class="header">
      <img id="logo" src="../assets/image/logo.png" />
    </div>
    <main v-if="step === 1">
      <el-col :span="12" :offset="6" :xs="{ span: 18, offset: 3 }">
        <br />
        <div class="classInfo" style="margin-bottom: 25px">
          <p>{{ apiMessage }}</p>
        </div>
      </el-col>
    </main>
    <main v-if="step === 2">
      <el-col :span="12" :offset="6" :xs="{ span: 18, offset: 3 }">
        <div class="classInfo error">
          <p>{{ apiMessage }}</p>
        </div>
      </el-col>
    </main>
    <main v-if="dataKey">
      <div>
        <img
          src="../assets/image/result.gif"
          style="max-width: 150px; margin: 0 auto; display: block"
        />
        <div style="text-align: center">
          <h4>
            {{ dataKey.name }}
          </h4>
          <h4>綁定成功</h4>
          <p style="margin: 20px 0">
            您已經可以用 APP 查詢<br />生命建造課程的成績
          </p>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
import { deviceCertification, checkBinding } from '../api/auth'

export default {
  name: 'SigninApp',
  data () {
    return {
      pageLoading: false,
      step: 0,
      apiMessage: '',
      dataKey: null
    }
  },
  computed: {},
  created () {
    this.deviceCertification()
    if (this.$route.query.c && this.$route.query.u) {
      this.handleCheckBinding()
    }
  },
  methods: {
    deviceCertification () {
      deviceCertification({
        ApplyData: this.$route.query.d,
        certification_code: this.$route.query.c,
        uuid: this.$route.query.u
      })
        .then((res) => {
          this.apiMessage = res.message

          if (res.code === '200') {
            this.step = 1
          }

          if (res.code === '500') {
            this.step = 2
          }
        })
        .catch((err) => {
          this.step = 2
          console.log(err)
        })
    },
    handleCheckBinding () {
      checkBinding({ c: this.$route.query.c, u: this.$route.query.u })
        .then((res) => {
          this.dataKey = res.content
        })
        .catch((e) => {
          console.log(e)
        })
    }
  }
}
</script>

<style scope>
#logo {
  height: 100%;
}

.header {
  position: relative;
  padding: 5px 0;
  height: 50px;
  background-color: #1c404c;
  user-select: none;
  z-index: 1;
  text-align: center;
}

.desc {
  padding-top: 1rem;
  padding-bottom: 1rem;
  font-size: 12px;
}

.el-select {
  display: block;
}

.el-form--inline .el-form-item {
  display: flex;
  margin-right: 0;
}

.el-form--inline .el-form-item__content {
  flex: 1;
}

.classInfo {
  border: 2px solid #008088;
  background-color: #f2f2f2;
  color: #008088;
  text-align: center;
  margin-top: 1rem;
  margin-bottom: 1rem;
}

.classInfo.error {
  color: red;
  padding: 1rem;
}

.classInfo.fat {
  padding-top: 1rem;
  padding-bottom: 1rem;
}

.title {
  background-color: #008088;
  color: white;
  text-align: center;
  padding: 0.5em;
}
</style>
